/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef } from 'react';
import { cn } from '@Utils/index';
import { IDropDownData } from '@Constants/interface';
import { Button } from '@Components/RadixComponents/Button';
import {
  Command,
  CommandGroup,
  CommandItem,
} from '@Components/RadixComponents/Command';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@Components/RadixComponents/Popover';
import useDebouncedInput from '@Hooks/useDebouncedInput';
import Icon from '@Components/common/Icon';
import hasErrorBoundary from '@Components/common/hasErrorBoundary';
import Searchbar from '@Components/common/SearchBar';
import isEmpty from '@Utils/isEmpty';

function GroupCombobox({
  options = [],
  multiple = false,
  choose = 'id',
  value,
  placeholder,
  onChange,
  onFocus,
  id,
  className,
  disabled,
  isLoading = false,
  dropDownSize = 'drop-lg',
  placeholderClassName,
  hasLeftIcon,
  leftIconName,
  lengthOfOptions = 0,
  style,
  checkBox = false,
  enableSearchbar = true,
  showSelectAllBtn = false,
  handleSelectAll,
  handleClearAll,
  selectAllBtnDisabled = false,
}: IDropDownData) {
  const [open, setOpen] = React.useState(false);
  const [allCheckbox, setAllCheckBox] = React.useState<any>(false);
  const [searchText, setSearchText] = React.useState('');
  const [filteredOptionsData, setFilteredOptionsData] = React.useState<any>([]);
  const [dropDownWidth, setDropDownWidth] = React.useState<number | undefined>(
    0,
  );

  const handleSelect = (currentValue: any) => {
    if (onFocus) onFocus();
    if (multiple) {
      const selectedValues = Array.isArray(value) ? [...value] : [];
      const selectedIndex = selectedValues.indexOf(currentValue);
      if (selectedIndex === -1) {
        selectedValues.push(currentValue);
      } else {
        selectedValues.splice(selectedIndex, 1);
      }
      if (onChange) {
        if (lengthOfOptions !== 0) {
          if (selectedValues.length > lengthOfOptions) {
            return;
          }
        }
        onChange(selectedValues);
      }
    } else {
      const selectedValue = currentValue === value ? '' : currentValue;
      if (onChange) {
        onChange(selectedValue);
      }
      setOpen(false);
    }
  };

  // for search
  const [searchTextData, handleChangeData] = useDebouncedInput({
    ms: 400,
    init: searchText,
    onChange: debouncedEvent =>
      setSearchText(debouncedEvent.target.value?.toLowerCase()),
  });

  const triggerRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    setDropDownWidth(triggerRef.current?.clientWidth);
  }, [triggerRef.current?.clientWidth]);

  useEffect(() => {
    const filteredOptions = options?.map((option: Record<string, any>) => {
      return {
        ...option,
        subCategories: option?.subCategories?.filter(
          (subCat: Record<string, any>) =>
            subCat?.name?.toLowerCase()?.includes(searchText),
        ),
      };
    });
    setFilteredOptionsData(filteredOptions);
  }, [searchText]);

  useEffect(() => {
    setFilteredOptionsData(options);
  }, [options]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild ref={triggerRef}>
        <Button
          id={id as string}
          variant="dropDown"
          size={dropDownSize}
          role="combobox"
          disabled={disabled}
          aria-expanded={open}
          className={cn(
            'naxatw-group naxatw-flex naxatw-items-center naxatw-justify-between naxatw-gap-2 naxatw-bg-white hover:naxatw-border-secondary-500 disabled:!naxatw-cursor-not-allowed',
            className,
          )}
          onClick={() => setOpen(true)}
        >
          <>
            <div className="naxatw-flex naxatw-items-center naxatw-justify-center naxatw-gap-2">
              {hasLeftIcon && (
                <Icon
                  name={leftIconName ?? ''}
                  className="naxatw-flex naxatw-h-6 naxatw-w-6 naxatw-shrink-0 naxatw-items-center naxatw-justify-center naxatw-text-[24px] naxatw-font-light naxatw-leading-6 naxatw-text-matt-200 naxatw-duration-200 group-hover:naxatw-text-secondary-500"
                />
              )}
              {multiple ? (
                <div className="naxatw-flex naxatw-flex-wrap">
                  {Array.isArray(value) && value.length > 0 ? (
                    value.length === 1 ? (
                      <span className="naxatw-body-sm  naxatw-line-clamp-1  naxatw-text-start naxatw-text-matt-200">
                        {options?.find(
                          (option: IDropDownData) =>
                            option[choose as keyof IDropDownData] === value[0],
                        )?.label || '1 Selected'}
                      </span>
                    ) : (
                      <span className="naxatw-line-clamp-1 naxatw-text-start naxatw-font-medium">
                        {value.length} Selected
                      </span>
                    )
                  ) : (
                    <p
                      className={cn(
                        'naxatw-body-sm  naxatw-line-clamp-1  naxatw-text-start naxatw-text-[#667085]',
                        placeholderClassName,
                      )}
                    >
                      {placeholder || 'Choose'}
                    </p>
                  )}
                </div>
              ) : (
                <>
                  {value ? (
                    <p className="naxatw-body-sm  naxatw-line-clamp-1  naxatw-text-start naxatw-text-matt-200">
                      {options.find(
                        (option: IDropDownData) =>
                          option[choose as keyof IDropDownData] === value,
                      )?.label || 'No Name Found'}
                    </p>
                  ) : (
                    <p
                      className={cn(
                        'naxatw-body-sm  naxatw-line-clamp-1  naxatw-text-start naxatw-text-matt-200',
                        placeholderClassName,
                      )}
                    >
                      {placeholder || 'Choose'}
                    </p>
                  )}
                </>
              )}
            </div>
            <Icon
              name="expand_more"
              className="naxatw-flex naxatw-h-6 naxatw-w-6 naxatw-shrink-0 naxatw-items-center naxatw-justify-center naxatw-text-[24px] naxatw-font-light naxatw-leading-6 naxatw-text-matt-200 naxatw-duration-200 group-hover:naxatw-text-secondary-500"
            />
          </>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="naxatw-bg-white naxatw-p-[0px]"
        style={{ width: `${dropDownWidth}px`, ...style }}
      >
        {enableSearchbar ? (
          <Searchbar
            value={searchTextData}
            onChange={handleChangeData}
            isSmall
            className="searchbar-dropdown !naxatw-py-3 focus:!naxatw-border-grey-600"
            wrapperStyle="!naxatw-h-auto"
          />
        ) : null}

        {/* select all btn */}
        {showSelectAllBtn ? (
          <div
            className="select-all-container naxatw-flex naxatw-items-center naxatw-gap-2 naxatw-px-4 naxatw-py-1"
            onClick={() => {
              setAllCheckBox(!allCheckbox);
              if (!allCheckbox) {
                handleSelectAll();
              } else {
                handleClearAll();
              }
            }}
          >
            <input
              type="checkbox"
              checked={allCheckbox}
              className="naxatw-body-sm custom-checkbox naxatw-relative naxatw-h-4 naxatw-max-h-4 naxatw-min-h-4 naxatw-w-4 naxatw-min-w-4 naxatw-max-w-4"
              disabled={selectAllBtnDisabled}
            />
            <p className="naxatw-text-sm naxatw-text-matt-100">Select All</p>
          </div>
        ) : null}

        <div className="scrollbar search-scrollbar naxatw-block naxatw-max-h-[10rem] naxatw-overflow-y-auto">
          <Command className="naxatw-m-0 naxatw-p-0">
            {isLoading && <p>Loading ...</p>}
            <CommandGroup>
              {filteredOptionsData.length ? (
                filteredOptionsData?.map((option: IDropDownData) => (
                  <div className="options-container" key={option.id}>
                    {!isEmpty(option.subCategories) && (
                      <p className="naxatw-px-3 naxatw-py-1 naxatw-text-[0.938rem] naxatw-font-semibold naxatw-leading-[20px] naxatw-text-matt-100">
                        {option.label || '-'}
                      </p>
                    )}
                    {option?.subCategories?.map((item: Record<string, any>) => (
                      <CommandItem
                        key={item.id}
                        className="sub-category-item naxatw-ml-2 naxatw-flex naxatw-items-center naxatw-gap-1"
                        onSelect={() =>
                          handleSelect(item[choose as keyof IDropDownData])
                        }
                      >
                        {!checkBox ? (
                          <Icon
                            name="done"
                            className={`naxatw-text-[20px] ${
                              !multiple
                                ? value === item[choose as keyof IDropDownData]
                                  ? 'naxatw-opacity-100'
                                  : 'naxatw-opacity-0'
                                : Array.isArray(value) &&
                                    value.includes(
                                      item[choose as keyof IDropDownData],
                                    )
                                  ? 'naxatw-opacity-100'
                                  : 'naxatw-opacity-0'
                            }`}
                          />
                        ) : (
                          <Icon
                            name={
                              !multiple
                                ? value === item[choose as keyof IDropDownData]
                                  ? 'check_box'
                                  : 'check_box_outline_blank'
                                : Array.isArray(value) &&
                                    value.includes(
                                      item[choose as keyof IDropDownData],
                                    )
                                  ? 'check_box'
                                  : 'check_box_outline_blank'
                            }
                            className="naxatw-text-[20px]"
                          />
                        )}
                        <p className="naxatw-text-[0.875rem] naxatw-text-matt-200">
                          {' '}
                          {item.name}
                        </p>
                      </CommandItem>
                    ))}
                  </div>
                ))
              ) : (
                <div className="naxatw-body-sm naxatw-line-clamp-1 naxatw-flex naxatw-h-[4.25rem] naxatw-items-center  naxatw-justify-center  naxatw-text-start naxatw-text-matt-200">
                  No Data Found.
                </div>
              )}
            </CommandGroup>
          </Command>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default hasErrorBoundary(GroupCombobox);
